import React, {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";

import SectionBox from "../../elements/SectionBox/SectionBox";

import "./CampaignDetailsPage.scss";

import {callAPI} from "../../utils/utils";

const CampaignLinkBox = (props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [ link, setLink ] = useState("");
  const [ loading, setLoading ] = useState(true);

  const copySource = () => {
    navigator.clipboard.writeText(link).then(() => {
      enqueueSnackbar(t("CampaignAdsBox.CopySuccess"), {variant:'success'});
    });
  }

  useEffect(() => {
    callAPI("campaigns/details", "POST", {hash: props.hash}).then((data) => {
      setLink(data.link);
      setLoading(false);
    });
  }, [props.hash]);

  return (
    <SectionBox loading={loading} headline={"CampaignLinkBox.Headline"} info={"CampaignLinkBox.InfoText"} width={1000}>
      <div className={'campaign-link__box'} onClick={copySource}>
        {link}
      </div>
    </SectionBox>
  );
}

export default CampaignLinkBox;